import { createSetAtom } from '~shared/atoms/utils/createSetAtom';

export const selectedQuestionIds = createSetAtom(new Set<string>());
export const questionIdsToDelete = createSetAtom(new Set<string>());
